import { Injectable } from '@angular/core';

@Injectable()
export class LanguagesService {
    availables() {
        return ['fr', 'en', 'nl', 'de', 'es', 'pt'];
    }
}